import { render, staticRenderFns } from "./AnimalDraftIcons.vue?vue&type=template&id=272af55a"
import script from "./AnimalDraftIcons.vue?vue&type=script&lang=ts"
export * from "./AnimalDraftIcons.vue?vue&type=script&lang=ts"
import style0 from "./AnimalDraftIcons.vue?vue&type=style&index=0&id=272af55a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports